import type { MouseEventHandler } from 'react'
import React from 'react'
import listSVGIcon from './icons'

export interface SvgIconProps {
  name: string
  className?: string
  onClick?: MouseEventHandler<HTMLSpanElement>
  fill?: string
  style?: object
  antMode?: boolean
  height?: number
  width?: number
  title?: string
}
export default function SvgIcon(props: SvgIconProps) {
  const { className = '', name, height = 20, width = 20, ...rest } = props
  const iconElement = listSVGIcon[name]
  if (!iconElement) return null
  return (
    <span className={`d-flex justify-content-center align-item-center ${className}`} {...rest}>
      {React.cloneElement(iconElement, {
        height: height,
        width: width,
      })}
    </span>
  )
}
